module.exports = __webpack_public_path__ + "img/school.b9f782df.jpeg";